<template>
  <router-view/>
</template>

<script>
export default {
  name: 'Student',
  data: () => ({
  }),
  mounted() {
  },
  methods: {
  },
};
</script>

<style>

</style>
